module.exports = __webpack_public_path__ + "static/img/logo.82b9c7a.png";


//////////////////
// WEBPACK FOOTER
// ./packages/assets/logo.png
// module id = /KAl
// module chunks = 1